import React from "react";
import { Select } from "@paylixecommerce/shared/components";


const MultiSelect = ({ label, options, noOptionsMessage, closeMenuOnSelect, isSearchable, setFieldTouched, onlyCustomChange, onChange, name, placeholder, setFieldValue, values, touched, errors }) => {

	let isError = errors[name] && touched[name];

	return <div className="mb-4">
		<label className="paylixecommerce-label" htmlFor={name}>{label}</label>

		<Select
			options={options}
			className={`${isError && "is-invalid-select"}`}
			id={name}
			name={name}
			isMulti={true}
			noOptionsMessage={noOptionsMessage}
			closeMenuOnSelect={closeMenuOnSelect || false}
			placeholder={placeholder}
			isSearchable={isSearchable || false}
			backspaceRemovesValue={true}
			onBlur={() => setFieldTouched(name, true)}
			value={values[name]}
			onChange={options => {
				if(onlyCustomChange) {
					if(onChange) {
						onChange(options)
					}
				} else {
					setFieldValue(name, options)
					if(onChange) {
						onChange(options)
					}
				}

			}}
		/>

		{isError && <div className="invalid-feedback">{errors[name]}</div>}
	</div>
}

export default MultiSelect;
